export default {
    page_title: "Kevi | Reporte de Clientes",
    title: "Reporte de Clientes",
    active_clients_description:
        "Total de clientes con al menos una compra en los {0} días anteriores al inicio de cada mes",
    headings: {
        active_clients: "Clientes activos",
        retention_rate: "Tasa de aprovechamiento",
        clients_by_action: "Clientes por acción",
    },
    actions: {
        retained: "Retenidos (< {0}d)",
        reactivated: "Reactivados (entre {0}d y {1}d)",
        recovered: "Recuperados (> {0}d)",
        new_first_purchase: "Nuevos (1ra Compra)",
    },
    filters: {
        client_segment: "Segmento",
    },
};
